import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="relative w-full bg-foreground-950 text-white">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 pt-14 md:pt-20 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 mb-12">
          <div className="md:col-span-5">
            <h3 className="font-heading text-2xl md:text-3xl font-light text-white">
              Stay Updated
            </h3>
            <p className="mt-2 text-foreground-400 text-sm leading-relaxed max-w-sm">
              Get the latest guides, comparisons, and insights about the acbuy spreadsheet tracking system delivered straight to your inbox.
            </p>

            <form
              data-readdy-form
              action="https://readdy.ai/api/form/d8tpb4r9b1tpbugifsog"
              method="POST"
              className="mt-6 space-y-3 max-w-sm"
            >
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                className="newsletter-honeypot"
              />
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="Enter your email"
                  className="flex-1 bg-transparent border-b border-foreground-600 px-2 py-3 text-sm text-white placeholder:text-foreground-500 focus:outline-none focus:border-primary-400 transition-colors"
                />
                <button
                  type="submit"
                  className="px-6 py-3 bg-white text-foreground-950 rounded-full text-sm font-semibold hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2 justify-center"
                >
                  Subscribe
                  <i className="ri-arrow-right-line text-xs"></i>
                </button>
              </div>
            </form>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">Categories</h4>
            <nav className="space-y-2">
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap underline-offset-2 hover:underline"
                >
                  {cat.name}
                </a>
              ))}
            </nav>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">Contact</h4>
            <div className="space-y-3">
              <a href="mailto:hello@acbuyspreadsheet.bond" className="flex items-center gap-2 text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">
                <i className="ri-mail-line text-sm"></i>
                hello@acbuyspreadsheet.bond
              </a>
              <div className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-phone-line text-sm"></i>
                +1 (555) 123-4567
              </div>
            </div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mt-6 mb-3">Address</h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              123 Commerce Street
              <br />
              Suite 400, Business District
              <br />
              New York, NY 10001
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <span className="text-sm text-foreground-400 whitespace-nowrap">Instagram</span>
            <span className="text-sm text-foreground-400 whitespace-nowrap">Twitter</span>
            <span className="text-sm text-foreground-400 whitespace-nowrap">LinkedIn</span>
          </div>

          <p className="text-sm text-foreground-500 whitespace-nowrap">
            &copy; 2026 acbuyspreadsheet.bond
          </p>

          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap underline-offset-2 hover:underline">Privacy Policy</a>
            <a href="#" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap underline-offset-2 hover:underline">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}